// extracted by mini-css-extract-plugin
export default {"container":"PopupConfirm_container__pNY49","content":"PopupConfirm_content__QQjEM","buttons":"PopupConfirm_buttons__p+xcP"};